<script lang="ts">
    import CustomButton from "./CustomButton.svelte";
    import Icon from "../Icon/Icon.svelte";

    export let icon: string;
    export let title: string;
    export let message: string;
    export let confirmLabel: string;
    export let onConfirm: () => void;
</script>

<div class="popup-overlay">
    <div class="popup">
        <h2>
            {#if icon}
                <Icon name={icon} extraClass="mr-1" />
            {/if}

            {title}
        </h2>
        <p>{message}</p>

        <CustomButton label={confirmLabel} onClick={onConfirm} />
    </div>
</div>

<style>
    .popup-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
    }

    .popup {
        background: white;
        padding: 24px;
        border-radius: 12px;
        width: 90%;
        max-width: 420px;
        text-align: center;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    }

    h2 {
        margin-bottom: 12px;
    }

    p {
        margin-bottom: 20px;
    }
</style>
